import type { ReactElement } from "react";

import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/modules/leads-search-filters/constants";

import type { ICrmFilterResultProps } from "./types";
import { getAllChipText, getChipDisplayText, getAggregatedChipText } from "./utils/utils";

const THRESHOLD_FOR_CHIPS_AGGREGATION = 25;

const CrmFilterChipsItems = ({
    values,
    fields,
    fieldLabels,
    isExpanded,
    hideActionButton,
    onDelete,
}: ICrmFilterResultProps): ReactElement | null => {
    const chipItems = values?.flatMap(({ fieldName, fieldValues }) => {
        if (!fieldValues) {
            return [];
        }

        if (fieldValues.length === 0) {
            return [
                {
                    id: fieldName,
                    text: getAllChipText(fieldName, fieldLabels),
                    fieldName: fieldName,
                    isAggregated: true,
                },
            ];
        }

        if (fieldValues.length >= THRESHOLD_FOR_CHIPS_AGGREGATION) {
            return [
                {
                    id: fieldName,
                    text: getAggregatedChipText(fieldName, fieldValues, fields, fieldLabels),
                    fieldName: fieldName,
                    isAggregated: true,
                },
            ];
        }

        return fieldValues.map((val) => ({
            id: val,
            text: getChipDisplayText(fieldName, val, fields, fieldLabels),
            fieldName: fieldName,
        }));
    });

    if (!chipItems) {
        return null;
    }

    return (
        <LimitedChipItems
            items={chipItems ?? []}
            onDelete={onDelete}
            maxItems={MAX_CHIPS_GROUP_AMOUNT}
            hideActionButton={hideActionButton}
            isTabExpanded={isExpanded}
        />
    );
};

export default CrmFilterChipsItems;
